import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { FileText, ArrowRight, Sprout } from "lucide-react";
import { api } from "@/lib/api";
import { t } from "@/lib/i18n";

const NATURE = { teoria: "Teoria", dato_operativo: "Dato operativo", strumento_decisionale: "Strumento decisionale" };

export const FileCard = ({ id, tree, onSelectNode }) => {
  const [file, setFile] = useState(null);
  useEffect(() => { setFile(null); api.get("/files").then((r) => setFile(r.data.find((f) => f.id === id) || false)); }, [id]);
  if (file === null) return <div className="surface p-6 text-sm text-muted-foreground">{t("Carico il documento…")}</div>;
  if (!file) return <div className="surface p-6 text-sm text-muted-foreground">{t("Documento non trovato.")}</div>;
  const branch = tree.find((b) => b.id === file.primary_branch);
  const cross = (Array.isArray(file.cross_branches) ? file.cross_branches : []).map((c) => tree.find((b) => b.id === c)).filter(Boolean);
  const feeds = branch ? (branch.children || []).filter((c) => (c.files || []).includes(file.id)) : [];
  return (
    <article data-testid="file-card" className="surface p-6 space-y-5">
      <div className="flex items-start gap-3">
        <span className="h-10 w-10 rounded-md bg-[#B8895A]/15 border border-[#B8895A]/40 flex items-center justify-center text-[#C9A27C] shrink-0"><Sprout size={18} /></span>
        <div className="min-w-0">
          <div className="eyebrow">{t("Radice")} · {file.kind}{file.author ? ` · ${file.author}` : ""}</div>
          <h2 data-testid="file-card-title" className="font-heading text-xl font-semibold leading-tight mt-1">{file.name}</h2>
          <div className="flex flex-wrap gap-2 mt-2 text-[11px]">
            <span className={`px-2 py-0.5 rounded-full border ${file.status === "assimilato" ? "border-emerald-500/40 text-emerald-400" : "border-border text-muted-foreground"}`}>{file.status}</span>
            {file.nature && <span className="px-2 py-0.5 rounded-full border border-border text-muted-foreground">{t(NATURE[file.nature] || file.nature)}</span>}
          </div>
        </div>
      </div>
      {file.summary && <p className="text-sm text-muted-foreground leading-relaxed">{file.summary}</p>}
      {branch && (
        <div>
          <div className="eyebrow mb-2">{t("Nutre il ramo")}</div>
          <button data-testid="file-card-branch" onClick={() => onSelectNode(branch.id)} className="flex items-center gap-2 text-sm font-medium hover:underline" style={{ color: branch.color }}>
            <span className="h-2.5 w-2.5 rounded-full" style={{ background: branch.color }} />{branch.code} · {branch.title}
          </button>
          {feeds.length > 0 && (
            <div className="flex flex-wrap gap-1.5 mt-2">
              {feeds.map((c) => <button key={c.id} onClick={() => onSelectNode(c.id)} className="text-xs px-2 py-1 rounded-md border border-border hover:bg-accent">{c.title}</button>)}
            </div>
          )}
        </div>
      )}
      {cross.length > 0 && (
        <div>
          <div className="eyebrow mb-2">{t("Collegamenti trasversali")}</div>
          <div className="flex flex-wrap gap-1.5">{cross.map((b) => <button key={b.id} onClick={() => onSelectNode(b.id)} className="text-xs px-2 py-1 rounded-md border" style={{ borderColor: b.color, color: b.color }}>{b.title}</button>)}</div>
        </div>
      )}
      <Link to="/corpus" data-testid="file-card-corpus-link" className="inline-flex items-center gap-1 text-xs text-primary"><FileText size={12} /> {t("Apri nel corpus")} <ArrowRight size={12} /></Link>
    </article>
  );
};
